<template>
  <b-container class="card-container">
    <h4>Users</h4>
    <b-card no-body>
      <b-table :items="users" :fields="['email', 'name', 'team', 'projects_count', 'voices_count', 'sequences_count', 'current_period', 'created', 'login']">
        <template v-slot:cell(email)='data'>
          <a target="_blank" :href="`https://console.firebase.google.com/u/0/project/${config && config.firebase_config ? config.firebase_config.projectId : 'puppet-dev'}/firestore/data~2Fuser~2F${data.item.id}`">{{data.value}}</a>
        </template>
        <template v-slot:cell(team)='data'>
          <span v-if="data.value && data.value.name">{{data.value.name}}</span>
        </template>
        <template v-slot:cell(created)='data'>
          {{data.value | date}}
        </template>
        <template v-slot:cell(current_period)='data'>
          <span v-if="data.item.team && data.item.team.name"><span v-if="data.item.team.current_period && data.item.team.current_period.id && data.item.team.current_period.usage[data.item.id] && data.item.team.current_period.usage[data.item.id].recipients">{{data.item.team.current_period.usage[data.item.id].recipients}}</span><span v-else>0</span> / {{data.item.team.max_usage_in_period_per_user || 0}}</span>
        </template>
        <template v-slot:cell(login)='data'>
          <b-button @click="generate_login_link(data.item.email)" size='sm' variant='secondary'>Login</b-button>
        </template>
      </b-table>
    </b-card>

    <h4>Team</h4>
    <b-card no-body>
      <b-table :items="teams" :fields="['name', 'members_count', 'canceled', 'trial', 'plan', 'plan_quantity', 'period_end', 'stripe', 'created']">
        <template v-slot:cell(name)='data'>
          <a target="_blank" :href="`https://console.firebase.google.com/u/0/project/${config && config.firebase_config ? config.firebase_config.projectId : 'puppet-dev'}/firestore/data~2Fteam~2F${data.item.id}`">{{data.value}}</a>
        </template>
        <template v-slot:cell(period_end)='data'>
          {{data.item.current_period_end | date}}
        </template>
        <template v-slot:cell(canceled)='data'>
          <span v-if="data.item.canceled"><b-badge variant='danger' class='text-white'>Canceled</b-badge></span>
        </template>
        <template v-slot:cell(trial)='data'>
          <span v-if="data.item.trial"><i class="far fa-check-circle"></i></span>
        </template>
        <template v-slot:cell(stripe)='data'>
          <a target="_blank" :href="data.item.subscription_link" v-if="data.item.subscription_link"><i class="fas fa-external-link-square"></i></a>
        </template>
        <template v-slot:cell(created)='data'>
          {{data.value | date}}
        </template>
      </b-table>
    </b-card>

    <!-- <h4>Projects</h4>
    <b-card no-body>
      <b-table :items="projects" :fields="['name', 'items_count', 'user', 'created']">
        <template v-slot:cell(name)='data'>
          <a :href="`/projects/${data.item.id}`" target="_blank">{{data.value}}</a>
        </template>
        <template v-slot:cell(user)='data'>
          <span v-if="data.value && data.value.email">{{data.value.email}}</span>
        </template>
        <template v-slot:cell(created)='data'>
          {{data.value | date}}
        </template>
      </b-table>
    </b-card>

    <h4>Voices</h4>
    <b-card no-body>
      <b-table :items="voices" :fields="['name', 'status', 'user', 'descript', 'created']">
        <template v-slot:cell(name)='data'>
          <a :href="`/voices/${data.item.id}`" target="_blank">{{data.value}}</a>
        </template>
        <template v-slot:cell(user)='data'>
          <span v-if="data.value && data.value.email">{{data.value.email}}</span>
        </template>
        <template v-slot:cell(descript)='data'>
          <span v-if="data.item.descript_project_id"><i class="far fa-check-circle"></i></span>
        </template>
        <template v-slot:cell(created)='data'>
          {{data.value | date}}
        </template>
      </b-table>
    </b-card> -->
  </b-container>
</template>

<script>

import { db, config } from '@/main.js'
import api from '@/lib/api.js'

export default {
  metaInfo: {title: 'Admin'},
  data() {
    return {
      users: [],
      projects: [],
      voices: [],
      teams: [],
      query: '',
      index: null
    }
  },
  firestore: function () {
    return {
      users: db.collection('user').orderBy('created', 'desc'),
      projects: db.collection('project').orderBy('created', 'desc'),
      voices: db.collection('voice').orderBy('created', 'desc'),
      teams: db.collection('team').orderBy('created', 'desc'),
    }
  },
  methods: {
    async generate_login_link(email) {
      let link = await api.generate_login_link(email)
      window.prompt("Copy to clipboard: Ctrl+C, Enter", link.data)
    }
  }
}
</script>

<style scoped>

</style>
